export const assumeFromNotificationParam = 'linkCurrentUser';

export const assumeTexts = {
    assumed: 'Oportunidade assumida — já está na sua agenda.',
    alreadyYours: 'Esta oportunidade já está na sua agenda.',
    getTakenBy: (name) => `Esta oportunidade já está com ${name}.`,
};
